export const EID_SIGNING_METHOD = {
  AdES: 'AdES',
  QES: 'QES',
};

export const EID_HUB_ITEM_SIGNING_METHOD_KEY = {
  BELGIAN_EID_ADES: 'eidHubBeBeidSign',
  BELGIAN_EID_QES: 'beidQes',
  ESTONIAN_EID_ADES: 'eidHubEeEsteidSign',
  ESTONIAN_EID_QES: 'estidQes',
  ESTONIAN_MOBILE_EID_ADES: 'eidHubEeEsteidMobileSign',
  ESTONIAN_MOBILE_EID_QES: 'estidMobileQes',
  FREJA_EID_ADES: 'eidHubFrejaSign',
  FINNISH_EID_ADES: 'eidHubFiFtnSign',
  IDIN_EID_ADES: 'eidHubNlIdinSign',
  ITSME_EID_ADES: 'eidHubBeItsmeSign',
  ITSME_EID_QES: 'itsmeQes',
  MITID_EID_ADES: 'eidHubDkMitidSign',
  NORWEGIAN_BANKID_ADES: 'eidHubNoBankidSign',
  GERMAN_NPA_ADES: 'eidHubDeNpaSign',
  SMARTID_EID_ADES: 'eidHubSmartidSign',
  SMARTID_EID_QES: 'smartidQes',
  SWEDISH_BANKID_ADES: 'eidHubSeBankidSign',
  SIMPLY_SIGN_ADES: 'eidHubSimplySignSign',
  SIMPLY_SIGN_QES: 'simplySignQes',
  ZEALID_QES: 'eidHubZealidSign',
  EVROTRUST_QES: 'eidHubEvrotrustSign',
  SIGN_ME_QES: 'eidHubDTrustSignMeSign',
};

export const EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY = {
  SE_BANKID: 'seBankid',
  NO_BANKID: 'noBankid',
  DK_NEMID: 'dkNemid',
  FI_FTN: 'fiFtn',
};
